import endereco from './endereco'

export default [
    {
        meta: {authenticated: true, layout: 'admin'},
        path: '/integracao',
        component: () => import('@/views/integracao/Index'),
        children: [
            ...endereco,
        ],
    },
]